import React from 'react';
import {
  Box,
  Button,
  Container,
  Typography
} from '@material-ui/core';

const Splash = () => {

    return (
        <Box
            display="flex"
            flexDirection="column"
            height="90%"
            justifyContent="center"
        >
            <Container maxWidth="md">
                <Typography
                    align="center"
                    color="textPrimary"
                    variant="h1"
                >
                Earn Money with Music on Amazon Alexa.
                </Typography>
                <Typography
                    align="center"
                    color="textPrimary"
                    variant="subtitle2"
                >
                Click the button to get started 100% Free.
                </Typography>
                <Typography
                    align="center"
                    color="textPrimary"
                    variant="subtitle2"
                >
                <Button variant="contained" href="#learn-more" color="primary">
                    Learn More
                </Button>
                </Typography>
                
            </Container>
        </Box>
    );
};

export default Splash;
